import { useContext } from 'react';

import { Context } from '../providers/ErrorHandlingProvider';

const useErrorHandling = () => useContext(Context);

export default useErrorHandling;
